import { DateTime } from "luxon";

export function calculateDiffYears(a: DateTime, b: DateTime): number {
  const diff = a.diff(b);

  return diff.toMillis() / 1000 / 365 / 24 / 3600;
}
